export type ClientSession = {
  role: "member" | "committee" | "admin" | "superadmin";
  full_name: string;
  userId: number;
};

export function readSession(): ClientSession | null {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(/(?:^|; )avt_session=([^;]*)/);
  if (!match) return null;
  try {
    const data = JSON.parse(decodeURIComponent(match[1]));
    if (data.role !== "admin" && data.role !== "committee" && data.role !== "member" && data.role !== "superadmin") return null;
    return {
      role: data.role,
      full_name: typeof data.full_name === "string" ? data.full_name : "",
      userId: Number(data.userId) || 0,
    };
  } catch {
    return null;
  }
}
